// extracted by mini-css-extract-plugin
export default {"mainContainer":"Contact_mainContainer__-kNfr","outro":"Contact_outro__kWnvA","iconsContainer":"Contact_iconsContainer__dcbn6","icon":"Contact_icon__uPRlS"};